import { Colors } from '@sigma-frontend-libs/commons'

import { FILE_TYPES, components, labelModes, sizes } from '@/utils'

import squircle from '@/components/icon/squircle'
import selectorOwner from '@/components/selector/owner'
import tag from '@/components/tag'

function renderSearchField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.$search,
        label: this.getTranslate('commons.labels.search'),
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.$search = event
        }
      }
    }
  )
}
function renderIdField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.id,
        label: this.getTranslate('commons.labels.id'),
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.id = event
        }
      }
    }
  )
}
function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}
function renderFileIconInFilter(h, color, size) {
  return h(
    squircle,
    {
      props: {
        iconSVG: 'folder-file',
        color: Colors[color],
        size
      }
    }
  )
}
function renderTypeSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.searchTypes,
        label: this.getTranslate('commons.labels.type'),
        items: this.typesItems,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        multiple: true,
        disabled: this.types.length > 0
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            tag,
            {
              props: {
                label: item.title,
                size: sizes.small,
                color: FILE_TYPES[item.value].color
              }
            }
          )
        },
        item: ({ item }) => {
          return h(
            'div',
            {
              class: 'faic grid-gap--8'
            },
            [
              renderFileIconInFilter.call(this, h, FILE_TYPES[item.value].color, sizes.small),

              h(
                'div',
                {
                  class: 'grid grid-gap--0'
                },
                [
                  item.title,
                  h('div', { class: 'tiny text--grey' }, FILE_TYPES[item.value].extensions.join(', '))
                ]
              )
            ]
          )
        }
      },
      on: {
        input: event => {
          this.searchTypes = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'files__filter'
    },
    [
      renderSearchField.call(this, h),
      renderIdField.call(this, h),
      renderSelectorOwner.call(this, h),
      renderTypeSelect.call(this, h)
    ]
  )
}
